import script from "./BlogNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BlogNavigation.vue?vue&type=style&index=0&id=7cdcce66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cdcce66"]])

export default __exports__